import { MATERIAL_CATALOG } from './catalogs';

export default function MaterialsSection({
    data,
    addMaterialTop,
    clearMat,
    setMaterials,
    delMat,
    MaterialsTable,
}) {
    return (
        <div className="card">
            <div className="section-title"><i></i>Материалы — нормы расхода и цены</div>
            <div className="actions" style={{ justifyContent: 'space-between', marginTop: 0 }}>
                <div className="row cols-3">
                    <div>
                        <label>Каталог материалов</label>
                        <select id="selMatCatalog">
                            {MATERIAL_CATALOG
                                .filter((x) => !(data.materials || []).some((m) => m.key === x.key))
                                .sort((a, b) => a.name.localeCompare(b.name, 'ru'))
                                .map((it) => (
                                    <option key={it.key} value={it.key}>{it.name}</option>
                                ))}
                        </select>
                    </div>
                    <div className="actions">
                        <button
                            className="ghost"
                            onClick={() => {
                                const key = document.getElementById('selMatCatalog')?.value;
                                addMaterialTop(key);
                            }}
                        >
                            Добавить из списка
                        </button>
                        <button className="ghost" onClick={() => addMaterialTop(null)}>+ Свой материал</button>
                    </div>
                </div>
                <button className="danger" onClick={clearMat}>Очистить материалы</button>
            </div>

            <MaterialsTable materials={data.materials || []} onChange={setMaterials} onDel={delMat} />
        </div>
    );
}
